module.exports = __webpack_public_path__ + "assets/img/intro-normal-2.f1ace645.jpg";